import React from 'react';
import { IAnswerMapping } from '../QuestionnairePrintView.service';
import styles from '../QuestionnairePrintView.module.scss';

interface IFullNameTemplateProps {
  answerMapping: Record<string, IAnswerMapping>;
}

const FullNameTemplate: React.FC<IFullNameTemplateProps> = ({ answerMapping }) => {
  const labels = ['Prefix', 'First Name', 'Middle Name', 'Last Name'];

  return (
    <div className={styles['group-type-answer']}>
      {labels.map((label, index) => (
        <div key={index} className={styles['sub-type-answer']}>
          <label>{label}: </label>
          <p>{answerMapping[String(index)]?.answerForQuestion || ''}</p>
        </div>
      ))}
    </div>
  );
};

export default FullNameTemplate;
